import React from 'react'
import PropTypes from 'prop-types'

import { useTranslation } from '@sm360/hooks'
import clsx from 'clsx'
import formatNumber from '../../../../../../utils/format-number.utils'

const Cashdown = ({ cashDown, priceRounding, extraClasses }) => {
    const { t } = useTranslation()

    const baseClass = 'vc-cashDown'
    const classNames = clsx(baseClass, extraClasses)

    const cashDownFormatted = formatNumber(cashDown, priceRounding)

    return <p className={classNames}>{t('paymentOptions.cashDown', { cashDownFormatted })}</p>
}

Cashdown.propTypes = {
    /** Cash Down */
    cashDown: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    /** Extra Classes */
    extraClasses: PropTypes.string,
    /** Rounding option for prices */
    priceRounding: PropTypes.string,
}

Cashdown.defaultProps = {
    extraClasses: '',
    cashDown: '',
    priceRounding: 'ROUND_UP',
}

export default Cashdown
